
import '../styles/dashboard.css'
import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext';
import BackLoader from '../components/backloader';


function Dashboard() {
    
    const navigate = useNavigate();
const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
const [loading, setLoading] =useState(false);
const [mycases, setMycases] = useState([]);
const [score, setScore] = useState({all:0,draft:0,concluded:0,notconcluded:0});
const [casetype, setCaseType]= useState({civil:0,criminal:0,motion:0});
const [gstatus, setGstatus]=useState("pending")
const [gradient, setGradient] = useState(`conic-gradient(
    #b30c0f 0% 30%,
    orange 30% 50%,
    red 50% 100%
  )`);


    useEffect(() => {
            
              onLoad();       
        }, []);

   useEffect(() => {

    

const all = mycases.reduce((sum, item) => sum + item.allc, 0);


  const civil = mycases.filter((e)=>e.caseTypeId==1).reduce((sum, item) => sum + item.allc, 0);
  const criminal = mycases.filter((e)=>e.caseTypeId==2).reduce((sum, item) => sum + item.allc, 0);
  const motion = mycases.filter((e)=>e.caseTypeId==6).reduce((sum, item) => sum + item.allc, 0);


setCaseType({civil:civil,criminal:criminal,motion})
 const civilper=(civil/all)*100;
 const criminalper = (criminal/all )*100;
 const motionper = (motion/all)*100;

 if(profile.role.id==1){


  const val1 = mycases.reduce((sum, item) => sum + item.draft, 0);
  const val2 = mycases.reduce((sum, item) => sum + item.concluded, 0);
  const val3 = mycases.reduce((sum, item) => sum + item.notConcluded, 0);
setScore({all:all,draft:val1,concluded:val2,notconcluded:val3});

setGradient(`conic-gradient(
    var(--primary) 0% ${civilper}%,
    red ${(civilper)}% ${civilper+criminalper}%,
    orange ${civilper+criminalper}% ${civilper+criminalper+motionper}%
  )`)

    } else{

      const all = mycases.reduce((sum, item) => sum + item.allc, 0);
      const val1 = mycases.reduce((sum, item) => sum + item.pending, 0);
      const val2 = mycases.reduce((sum, item) => sum + item.revised, 0);
      const val3 = mycases.reduce((sum, item) => sum + item.completed, 0);

      setScore({all:all,pending:val1,revised:val2,completed:val3});

    setGradient(`conic-gradient(
        var(--primary) 0% ${civilper}%,
        red ${(civilper)}% ${civilper+criminalper}%,
        orange ${civilper+criminalper}% ${civilper+criminalper+motionper}%
      )`)

    }
  

        }, [mycases]);  

      const onLoad= async()=>{
                //for account registration
            try {
    
                setLoading(true);
                const resp = await fetch(`${Constants.apiUrl}/report/dashboard/${profile.role.id}`, { 
                    method: 'GET',  headers: {'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                const data = await resp.json();
                setLoading(false);
                if(data.code==0){
                  setMycases(data.items);
                } else if(data.code==-10){
                          setIsExpired(true);
                      }
                
                } catch (error) {
                setLoading(false);
                console.error(error);   
                }
            }


  return (
    <div>
     
      <div className="dashboard">
      <div className="main-row">
     {profile.role.id==1 && <div className="left-cards">
          <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Total Cases</div>
            <div className="card-value">{score.all+score.draft}</div>
        
          </div>
          <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Ongoing Cases</div>
            <div className="card-value">{score.notconcluded}</div>
        
          </div>
        <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Concluded Cases</div>
            <div className="card-value">{score.concluded}</div>
        
          </div> 
    <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Pending Payment</div>
            <div className="card-value">{score.concluded}</div>
        
          </div> 
        

          
        </div>}   

     {profile.role.id!=1 && <div className="left-cards">
          <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>New Cases</div>
            <div className="card-value">{score.pending}</div>
        
          </div>
          <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Total Cases</div>
            <div className="card-value">{score.all}</div>
        
          </div>
        <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Cases Cleared</div>
            <div className="card-value">{score.completed}</div>
        
          </div> 
    <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Pending Cases</div>
            <div className="card-value" style={{color:'red'}}>{score.revised??0}</div>
        
          </div> 
     <div className="card">
            <div className="card-icon">
              <DynamicIcon iname='book-open' size={24} color={'white'}/>
            </div>
            <div>Flagged Cases</div>
            <div className="card-value" style={{color:'red'}}>0</div>
        
          </div>   

          
        </div>}  

    </div>

{profile.role.id==1 && <div className="mid-section">
    <div className="overview">
            <div className="chart-area">
              <h4>Filing Overview</h4>
              <div style={{
              background: gradient,
              height: "300px",
              width: "300px",
              borderRadius: "50%",
              marginTop: "10px",
            }}>

                <div className="pie-red"></div>
              </div>

            </div>
            <div className="case-summary">
              <div className="summary-box">
                <div className='in-summary-box'>
    <div className='circle-only' style={{backgroundColor: 'var(--primary)'}}></div>
                <div>Civil</div>
                </div>
                
                <p>{casetype.civil}</p>
              </div>
              <div className="summary-box">
                <div className='in-summary-box'>
                  <div className='circle-only' style={{backgroundColor: 'red'}}></div>
                <div>Criminal </div>
                </div>
                <p>{casetype.criminal}</p>
              </div>
              <div className="summary-box">
                <div className='in-summary-box'>
                  <div className='circle-only' style={{backgroundColor: 'orange'}}></div>
                <h3 style={{color:'orange'}}>Motion</h3>
                </div>
                
                <p>{casetype.motion}</p>
              </div>
          
            </div>
        </div>
          <div className="stati">
              <div className="stati-title">Case Statistics</div>
              
              <div className='stati-box'>
                <div className='stati-box-value'>{score.all+score.draft} cases opened this month</div>
                <div className='stati-box-past'>0% vs last month 0</div>
              </div>
              <div className='stati-box'>
                <div className='stati-box-value'>{score.notconcluded} cases pending hearing</div>
                <div className='stati-box-past'>0% vs last month 0</div>
              </div>
              <div className='stati-box'>
                <div className='stati-box-value'>{score.concluded} cases concluded this month</div>
                <div className='stati-box-past'>0% vs last month 0</div>
              </div>
              <div className='stati-box'>
                <div className='stati-box-value'>{score.draft} cases in draft</div>
                <div className='stati-box-past'>0% vs last month 0</div>
              </div>
          </div>
    </div>}

 {profile.role.id!=1 && 
 
 <div style={{display:'flex', marginTop:20}}>
  <div>Overview</div>
  <div style={{flex:1}}>
     <div className='holeGraph' style={{
              background: gradient,
              height: "300px",
              width: "300px",
              borderRadius: "50%",
              marginTop: "10px",
            }}></div>
    </div>
 

    <div style={{flex:1, display:'flex', flexDirection:'column', gap:24}}>
      <div class="radio-group">
          <label  className='radioeffect' onClick={()=>setGstatus('approved')}>  <span><DynamicIcon iname={`${gstatus=='approved'?'circle-check':'circle'}`} color={`${gstatus=='approved'?'var(--primary)':'var(--text)'}`} /></span><span>Cases Approved</span> </label>
          <label className='radioeffect'  onClick={()=>setGstatus('pending')}><span><DynamicIcon iname={`${gstatus=='pending'?'circle-check':'circle'}`} color={`${gstatus=='pending'?'var(--primary)':'var(--text)'}`} /></span><span>Pending Cases</span></label>
      </div>
    <div >
        <ul class="legend">
          <li><span class="box civil"></span> Civil Cases</li>
          <li><span class="box criminal"></span> Criminal Cases</li>
          <li><span class="box motion"></span> Motion</li>
       {/*    <li><span class="box affidavit"></span> Affidavit</li> */}
        </ul>
      </div>    
      </div>        
 </div>

 }   

  </div> 

  
  <BackLoader open={loading} />
    </div>
  );
}

export default Dashboard;